import { useEffect, useState } from "react";

const BASE_URL = "https://partyhousedatabase-rpft.onrender.com";

export default function AdminBookings() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter] = useState("All");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    fetchBookings();
  }, []);

  const fetchBookings = async () => {
    try {
      const res = await fetch(`${BASE_URL}/bookings/all`);
      const data = await res.json();
      setBookings(data);
    } catch (err) {
      alert("Failed to load bookings");
    }
    setLoading(false);
  };

  const updateStatus = async (id) => {
    const confirmUpdate = window.confirm("Mark this booking as CONFIRMED?");
    if (!confirmUpdate) return;

    try {
      const res = await fetch(`${BASE_URL}/bookings/status/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status: "Confirmed" }),
      });
      const result = await res.json();
      if (res.ok) {
        alert("Booking confirmed & email sent!");
        fetchBookings();
      } else {
        alert(result.error);
      }
    } catch (error) {
      alert("Server error");
    }
  };

  const filteredBookings = bookings
    .filter((b) => (filter === "All" ? true : b.status === filter))
    .filter((b) =>
      b.name.toLowerCase().includes(search.toLowerCase()) ||
      b.email.toLowerCase().includes(search.toLowerCase())
    );

  const totalBookings = bookings.length;
  const confirmed = bookings.filter((b) => b.status === "Confirmed").length;
  const pending = totalBookings - confirmed;

  // Pagination
  const totalPages = Math.ceil(filteredBookings.length / itemsPerPage);
  const displayedBookings = filteredBookings.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  if (loading) return <h2 style={{ textAlign: "center" }}>Loading dashboard...</h2>;

 return (
  <div style={{ padding: "40px", fontFamily: "'Segoe UI', sans-serif" }}>
    <h1 style={{ textAlign: "center", marginBottom: "30px", fontSize: "32px" }}>
      Bookings Dashboard
    </h1>

    {/* Stats Cards */}
    <div style={statsWrapper}>
      <div style={statCard}>
        <h3>Total Bookings</h3>
        <p>{totalBookings}</p>
      </div>

      <div style={{ ...statCard, background: "#d1e7dd", color: "#0f5132" }}>
        <h3>Confirmed</h3>
        <p>{confirmed}</p>
      </div>

      <div style={{ ...statCard, background: "#fff3cd", color: "#664d03" }}>
        <h3>Pending</h3>
        <p>{pending}</p>
      </div>
    </div>

    {/* Search */}
    <div style={{ textAlign: "right", marginBottom: "15px" }}>
      <input
        type="text"
        placeholder="Search name or email..."
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setCurrentPage(1);
        }}
        style={{
          padding: "10px 14px",
          borderRadius: "10px",
          border: "1px solid #ccc",
          fontSize: "15px",
          width: "260px",
        }}
      />
    </div>

    {/* Table Container */}
    <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: "12px",
        overflow: "hidden",
        background: "#fff",
        boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead style={{ background: "#f9fafb" }}>
          <tr>
            <th style={thStyle}>ID</th>
            <th style={thStyle}>Name</th>
            <th style={thStyle}>Email</th>
            <th style={thStyle}>Event Date</th>
            <th style={thStyle}>Guests</th>
            <th style={thStyle}>Services</th>
             <th style={thStyle}>Status</th>
            <th style={thStyle}>Action</th>
          </tr>
        </thead>

        <tbody>
          {displayedBookings.map((b, index) => (
            <tr
              key={b.id}
              style={{
                background: index % 2 === 0 ? "#fff" : "#f8f8f8",
                transition: "0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#eef2ff")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background =
                  index % 2 === 0 ? "#fff" : "#f8f8f8")
              }
            >
              <td style={tdStyle}>{b.id}</td>
              <td style={tdStyle}>{b.name}</td>
              <td style={tdStyle}>{b.email}</td>
<td style={tdStyle}>
  {new Date(b.event_date).toISOString().split("T")[0]}
</td>
              <td style={tdStyle}>{b.guests || "-"}</td>
              <td style={tdStyle}>{b.services || "-"}</td>

              <td style={tdStyle}>
                <span
                  style={{
                    padding: "6px 12px",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#fff",
                    background: b.status === "Confirmed" ? "#10b981" : "#f59e0b",
                  }}
                >
                  {b.status}
                </span>
              </td>

              <td style={tdStyle}>
                {b.status !== "Confirmed" ? (
                  <button
                    onClick={() => updateStatus(b.id)}
                    style={{
                      ...actionBtn,
                      background: "#10b981",
                      color: "#fff",
                    }}
                  >
                    Confirm & Email
                  </button>
                ) : (
                  <span
                    style={{
                      color: "#10b981",
                      fontWeight: "700",
                      fontSize: "15px",
                    }}
                  >
                    ✔ Completed
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    {/* Pagination */}
    <div
      style={{
        marginTop: "25px",
        display: "flex",
        justifyContent: "center",
        gap: "20px",
      }}
    >
      <button
        onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
        disabled={currentPage === 1}
        style={pageBtn}
      >
        Previous
      </button>

      <span style={{ fontSize: "16px", fontWeight: "600" }}>
        Page {currentPage} of {totalPages}
      </span>

      <button
        onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
        disabled={currentPage === totalPages}
        style={pageBtn}
      >
        Next
      </button>
    </div>
  </div>
);

}

// --- Styles ---
const thStyle = {
  textAlign: "left",
  padding: "15px",
  fontSize: "15px",
  color: "#374151",
  fontWeight: "600",
  borderBottom: "1px solid #e5e7eb",
};

const tdStyle = {
  padding: "15px",
  fontSize: "15px",
  color: "#111827",
  borderBottom: "1px solid #f1f5f9",
};

const actionBtn = {
  padding: "8px 14px",
  borderRadius: "8px",
  border: "none",
  fontSize: "14px",
  fontWeight: "600",
  cursor: "pointer",
  transition: "0.2s",
};

const pageBtn = {
  padding: "10px 18px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  background: "#fff",
  cursor: "pointer",
  fontSize: "15px",
  fontWeight: "600",
};

const statsWrapper = {
  display: "flex",
  justifyContent: "center",
  gap: "25px",
  marginBottom: "35px",
  flexWrap: "wrap",
};

const statCard = {
  background: "#fff",
  padding: "20px 40px",
  borderRadius: "12px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
  textAlign: "center",
};
